<header class="h-full w-full flex items-center justify-end px-8">
  
  <!-- Left Side: Search Bar Removed -->

  <!-- Right Side: Actions & Profile -->
  <div class="flex items-center gap-6 ml-4">

    <button
      type="button"
      class="inline-flex items-center justify-center rounded-md border border-[var(--border-color)] bg-[var(--bg-panel)] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[var(--bg-panel)]/80 disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="triggerWorkers()"
      [disabled]="isTriggeringWorkers()"
    >
      {{ isTriggeringWorkers() ? 'Triggering…' : 'Trigger Workers' }}
    </button>
    <button
      type="button"
      class="inline-flex items-center justify-center rounded-md border border-[var(--border-color)] bg-[var(--bg-panel)] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[var(--bg-panel)]/80 disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="triggerDietSync()"
      [disabled]="isTriggeringDietSync()"
    >
      {{ isTriggeringDietSync() ? 'Syncing...' : 'Trigger DIET Sync' }}
    </button>
    <button
      type="button"
      class="inline-flex items-center justify-center rounded-md border border-[var(--border-color)] bg-[var(--bg-panel)] px-3 py-1.5 text-xs font-semibold text-white hover:bg-[var(--bg-panel)]/80 disabled:opacity-50 disabled:cursor-not-allowed"
      (click)="triggerDermoscanSync()"
      [disabled]="isTriggeringDermoscanSync()"
    >
      {{ isTriggeringDermoscanSync() ? 'Syncing...' : 'Trigger DermoScan Sync' }}
    </button>
    @if (canUseDevProdSync()) {
      <button
        type="button"
        class="inline-flex items-center justify-center rounded-md border border-amber-500/40 bg-amber-500/10 px-3 py-1.5 text-xs font-semibold text-amber-100 hover:bg-amber-500/20"
        (click)="openDevProdSyncModal()"
      >
        Sync dev to prod
      </button>
    }

    
    <!-- Date/Time Display -->
    <div class="hidden sm:flex flex-col items-end">
      <span class="text-xs font-semibold text-white">{{ currentDate | date:'MMM d, y' }}</span>
      <span class="text-[10px] text-[var(--text-muted)]">{{ currentDate | date:'EEEE' }}</span>
    </div>

  </div>
</header>
